<template>
  <v-card>
    <v-form @submit.prevent="submitAddProject()" ref="addProjectForm">
      <v-card-title class="flex-container-space-between">
        <span class="headline">Add Project</span>
        <div>
          <v-switch color="indigo" class="mt-0" label="Active Project" v-model="project.active"></v-switch>
        </div>
      </v-card-title>
      <v-container grid-list-lg>
        <v-layout wrap>
          <v-flex xs12>
            <v-text-field label="* Name" v-model="project.name" :rules="nameRules"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-autocomplete
              label="* Client"
              :items="clients"
              v-model="project.clientId"
              item-text="name"
              :rules="clientRules"
              item-value="id"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12>
            <v-autocomplete
              label="Allocation matching"
              :items="['SITE', 'PROJECT']"
              v-model="project.allocationMatchType"
              item-text="name"
              :rules="allocationMatchRules"
            ></v-autocomplete>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="primaryGrey" flat @click="close()">Cancel</v-btn>
        <v-btn :color="primaryNeutral" flat type="submit" :loading="addingProject">Add</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import ProjectService from "@/services/requests/projectService";
import ClientService from "@/services/requests/clientService";
import ProjectValidation from "@/services/validation/projectValidation";
export default {
  mixins: [ProjectValidation],
  data() {
    return {
      project: {
        name: "",
        contactEmail: "",
        contactPhone: "",
        allocationMatchType: "SITE",
        clientId: "",
        active: true
      },
      clients: [],
      addingProject: false,
      loadingClients: false
    };
  },
  methods: {
    submitAddProject() {
      if (!this.$refs.addProjectForm.validate()) {
        this.snack({ text: "Please correct form errors", color: "red" });
        return;
      }
      this.addProject();
    },
    addProject() {
      this.loading = true;

      ProjectService.addProject(this.project)
        .then(result => {
          this.loading = false;
          //console.log(result);
          this.$store.commit("projects/addToArrayState", {
            prop: "projects",
            value: result.data.result
          });
          this.resetForm();
          this.snack({ text: "Project was added!", color: "green" });
          this.close();
        })
        .catch(err => {
          this.snackError();
          this.addingProject = false;
          console.log(err);
        });
    },
    getClients() {
      ClientService.getAllClients()
        .then(result => {
          //console.log(result);
          this.clients = result.data.result;
        })
        .catch(err => {
          this.snackError();
        });
    },
    resetForm() {
      this.project.name = "";
      this.project.clientId = "";
      this.project.location = "";
      this.project.contactEmail = "";
      this.project.contactPhone = "";
      this.$refs.addProjectForm.resetValidation();
    },
    close() {
      this.$emit("close");
    }
  },
  mounted() {
    this.getClients();
  }
};
</script>

<style>
</style>
